<template>
  <div class="playlist-page">
    <!-- Top Bar -->
    <div class="top-bar">
  <!--     <button class="back-button" @click="handleBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      
      </button> -->
      <button
        :class="$store.state.audioPlayerIsPlaying ? 'pulse' : ''"
        class="player-btn"
        @click="$root.$refs.audioPlayers.show([], null, '')"
        title="Back to player"
      >
        <svg style="min-width: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22">
          <rect x="2" y="3" width="20" height="14" rx="2"/>
          <circle cx="12" cy="10" r="3"/>
          <path d="M8 21h8M12 17v4"/>
        </svg>
      </button>
      <h1 class="page-title">My Playlists</h1>
      
      <!-- Action buttons - show when a playlist is selected -->
      <div class="top-actions" v-if="selectedPlaylist">
        <button class="top-action-btn edit-btn" @click="editPlaylist(selectedPlaylist)" title="Rename">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.159109 16.159107" fill="rgba(0,212,255,.5)" stroke="rgba(0,212,255,.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m11.499963 1.6591451a2.1213203 2.1213203 0 0 1 3 3l-9.5000004 9.4999999-4.00000002 1 1.00000002-4z"/></svg>
        </button>
        <button class="top-action-btn delete-btn" @click="deletePlaylist(selectedPlaylist)" title="Delete">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="rgba(255,59,48,.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="13" y1="1" x2="1" y2="13"/><line x1="1" y1="1" x2="13" y2="13"/></svg>
        </button>
      </div>
      
      <!-- Create button - show when nothing is selected -->
      <button class="create-button" @click="showCreateForm" v-if="!selectedPlaylist">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="white" stroke-width="2"><line x1="7" y1="0" x2="7" y2="14"/><line x1="0" y1="7" x2="14" y2="7"/></svg>
      </button>
    </div>

    <!-- Create/Edit Form -->
    <div class="form-overlay" v-if="showForm" @click="closeForm">
      <div class="form-container" @click.stop>
        <h2 class="form-title">{{ editingPlaylist ? 'Rename Playlist' : 'Create Playlist' }}</h2>
        <input 
          v-model="formName" 
          type="text" 
          class="form-input"
          placeholder="Playlist name"
          @keyup.enter="savePlaylist"
          autofocus
        />
        <div class="form-buttons">
          <button class="btn-cancel" @click="closeForm">Cancel</button>
          <button class="btn-save" @click="savePlaylist">
            {{ editingPlaylist ? 'Rename' : 'Create' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Playlists Grid -->
    <div class="playlist-grid">
      <div 
        v-for="playlist in $store.state.playLists" 
        :key="playlist.id"
        class="playlist-folder"
        :class="{ selected: selectedPlaylist && selectedPlaylist.id === playlist.id }"
        @click="openPlaylist(playlist)"
      >
        <!-- Selection checkbox - top left -->
        <div 
          class="selection-box" 
          :class="{ selected: selectedPlaylist && selectedPlaylist.id === playlist.id }"
          @click.stop="toggleSelection(playlist)"
        >
          <svg v-if="selectedPlaylist && selectedPlaylist.id === playlist.id" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>

        <div class="folder-main">
         
          <div class="folder-info">
            <h3 class="folder-name">{{ playlist.name }}</h3>
            <p class="folder-count">{{ playlist.audios?.length }}</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" v-if="playlists.length === 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
        </svg>
        <p>No playlists yet</p>
        <button class="btn-create-first" @click="showCreateForm">
          Create your first playlist
        </button>
      </div>
    </div>

  <PlayList @playlistChanged="updatePlaylists" @deleteMe="deletePlaylist" ref="playList"/>
  </div>
</template>

<script>
import PlayList from './components/PlayList.vue';

export default {
  name: 'PlaylistList',
  components:{
    PlayList
  },  
  data() {
    return {
      playlists: [
        { id: 1, name: 'Favorites', audios:[] },
      ],
      showForm: false,
      formName: '',
      editingPlaylist: null,
      selectedPlaylist: null,
      lastHistoryPosition:0
    }
  },
  methods: {
    showCreateForm() {
      this.showForm = true;
      this.formName = '';
      this.editingPlaylist = null;
    },
    closeForm() {
      this.showForm = false;
      this.formName = '';
      this.editingPlaylist = null;
    },
    updatePlaylists (playlist) {
      const index = this.playlists.findIndex(p => p.id === playlist.id);
      if(index == -1) return
      this.playlists[index] = playlist
      this.$store.commit('setPlayLists',this.playlists)
    },
    savePlaylist() {
      if (!this.formName.trim()) return;

      if (this.editingPlaylist) {
        const index = this.playlists.findIndex(p => p.id === this.editingPlaylist.id);
        if (index !== -1) {
          this.playlists[index].name = this.formName;
        }
      } else {
        const newPlaylist = {
          id: Date.now(),
          name: this.formName,
          audios: []
        };
        this.playlists.push(newPlaylist);
      }
      this.$store.commit('setPlayLists',this.playlists)
      this.closeForm();
    },
    toggleSelection(playlist) {
      if (this.selectedPlaylist && this.selectedPlaylist.id === playlist.id) {
        // Deselect
        this.selectedPlaylist = null;
      } else {
        // Select
        this.selectedPlaylist = playlist;
      }
    },
    editPlaylist(playlist) {
      this.editingPlaylist = playlist;
      this.formName = playlist.name;
      this.showForm = true;
    },
    deletePlaylist(playlist) {
      const index = this.playlists.findIndex(p => p.id === playlist.id);
      if (index !== -1) {
        this.playlists.splice(index, 1);
        this.$store.commit('setPlayLists',this.playlists)
      }
      this.selectedPlaylist = null
    },
    openPlaylist(playlist) {
      this.selectedPlaylist = null;
      this.$refs.playList.show(playlist)
    }
  },
  mounted () {
    this.playlists = this.$store.state.playLists
    this.lastHistoryPosition = history.state?.position ?? 0;
  },
  beforeRouteLeave (/*to, from*/) {
    const currentPosition = history.state?.position ?? 0;
    if(currentPosition >= this.lastHistoryPosition) { return true } // not going back
    if(this.$store.state.publicationFormVisible) {
      this.$store.commit('setPublicationFormVisibility',false)
      return false
    }
    if(this.showForm  === true) {
      this.showForm = false
      return false
    }
    if(this.$store.state.audioPlayerVisibility === true) {
      this.$store.commit('setAudioPlayerVisibility',false)
      return false
    }
    if(this.$refs.playList.Display === true) {
      this.$refs.playList.close()
      return false
    }
  },
}
</script>

<style scoped>
.playlist-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0e26;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow-y: auto;
  z-index: 100;
}

.top-bar {
  position: sticky;
  top: 0;
  background: rgba(10, 14, 38, 0.95);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

/* .back-button {
  position: absolute;
  left: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #e0f7ff;
  transition: all 0.2s;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button svg {
  width: 24px;
  height: 24px;
} 

.back-button:hover {
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
} */

.player-btn {
  position: absolute;
  left: 20px;
  width: 40px;
  height: 40px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.35);
  border-radius: 50%;
  color: #00d4ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.pulse {
  animation: pulse-icon 1.2s ease-in-out infinite;
}
.player-btn:hover { background: rgba(0, 212, 255, 0.2); }

@keyframes pulse-icon {
  0%, 100% { transform: scale(1);    opacity: 1; }
  50%       { transform: scale(1.15); opacity: 0.6; }
}

.page-title {
  color: #e0f7ff;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.create-button {
  position: absolute;
  right: 20px;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border: none;
  border-radius: 50%;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 212, 255, 0.3);
}

.create-button svg {
  min-width: 15px;
  width: 15px;
  height: 15px;
}

.create-button:hover {
  box-shadow: 0 6px 16px rgba(0, 212, 255, 0.5);
}

/* Top Action Buttons */
.top-actions {
  position: absolute;
  right: 20px;
  display: flex;
}
.top-actions > * + * {
  margin-left: 8px;
}

.top-action-btn {
  width: 40px;
  height: 40px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.top-action-btn svg {
  min-width: 14px;
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.top-action-btn.edit-btn {
  color: #00d4ff;
  border-color: rgba(0, 212, 255, 0.5);
}

.top-action-btn.edit-btn:hover {
  background: rgba(0, 212, 255, 0.2);
  border-color: #00d4ff;
}

.top-action-btn.delete-btn {
  color: #ff3b30;
  border-color: rgba(255, 59, 48, 0.5);
}

.top-action-btn.delete-btn:hover {
  background: rgba(255, 59, 48, 0.2);
  border-color: #ff3b30;
}

.form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.form-container {
  background: rgba(10, 14, 38, 0.95);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 16px;
  padding: 32px 24px 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.form-title {
  color: #e0f7ff;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 20px 0;
  text-align: center;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.form-input {
  width: 100%;
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  color: #e0f7ff;
  font-size: 15px;
  margin-bottom: 20px;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
}

.form-input::placeholder {
  color: #64748b;
}

.form-buttons {
  display: flex;
}
.form-buttons > * + * {
  margin-left: 12px;
}

.btn-cancel,
.btn-save {
  flex: 1;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
}

.btn-cancel {
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: #e0f7ff;
}

.btn-cancel:hover {
  background: rgba(30, 41, 59, 1);
  border-color: rgba(0, 212, 255, 0.5);
}

.btn-save {
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.btn-save:hover {
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.5);
}

/* Grid Layout */
.playlist-grid {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Simple Square Cards */
.playlist-folder {
  position: relative;
  cursor: pointer;
  aspect-ratio: 1;
  background: rgba(30, 41, 59, 0.5);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.playlist-folder > * + * {
  margin-top: 12px;
}

.playlist-folder:hover {
  background: rgba(30, 41, 59, 0.7);
  border-color: rgba(0, 212, 255, 0.4);
  box-shadow: 0 4px 16px rgba(0, 212, 255, 0.2);
}

.playlist-folder.selected {
  background: rgba(0, 212, 255, 0.15);
  border-color: #00d4ff;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
}

/* Selection Checkbox - Top Left */
.selection-box {
  width: 20px;
  height: 20px;
  background: rgba(30, 41, 59, 0.8);
  border: 2px solid rgba(0, 212, 255, 0.3);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 10;
}

.selection-box:hover {
  border-color: #00d4ff;
  background: rgba(0, 212, 255, 0.1);
}

.selection-box.selected {
  background: #00d4ff;
  border-color: #00d4ff;
}

.selection-box svg {
  width: 12px;
  height: 12px;
  color: #0a0e26;
}

.folder-top {
  display: none;
}

.folder-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: none;
}
.folder-main  > * + * {
  margin-bottom: 12px;
}

.folder-icon {
  width: 48px;
  height: 48px;
  background: rgba(0, 212, 255, 0.15);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00d4ff;
  flex-shrink: 0;
}

.folder-icon svg {
  width: 24px;
  height: 24px;
}

.folder-info {
  text-align: center;
  width: 100%;
}

.folder-name {
  color: #e0f7ff;
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.folder-count {
  color: #00d4ff;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

/* Remove old action button styles */
.folder-actions {
  display: none;
}

.action-buttons {
  display: none;
}

.action-btn {
  display: none;
}

/* Empty State */
.empty-state {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;
}

.empty-state svg {
  width: 80px;
  height: 80px;
  color: rgba(0, 212, 255, 0.3);
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 18px;
  margin: 0 0 24px 0;
}

.btn-create-first {
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  color: #ffffff;
  border: none;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.btn-create-first:hover {
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.5);
}

/* Responsive */
@media (max-width: 768px) {
  .playlist-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
    padding: 16px;
  }

  .folder-icon {
    width: 40px;
    height: 40px;
  }

  .folder-icon svg {
    width: 20px;
    height: 20px;
  }

  .folder-name {
    font-size: 13px;
  }

  .action-btn {
    width: 26px;
    height: 26px;
  }

  .action-btn svg {
    width: 13px;
    height: 13px;
  }
}

@media (max-width: 480px) {
  .playlist-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
    padding: 12px;
  }

  .playlist-folder {
    padding: 12px;
  }

  .folder-icon {
    width: 36px;
    height: 36px;
  }

  .folder-icon svg {
    width: 18px;
    height: 18px;
  }

  .folder-name {
    font-size: 12px;
  }

  .action-btn {
    width: 24px;
    height: 24px;
  }

  .action-btn svg {
    width: 12px;
    height: 12px;
  }
}
</style>